import React from 'react';

import AlignLeftButton from './AlignLeftButton';

export default function installAlignLeftPlugin(config) {
  const { slate } = config.settings;

  slate.buttons.alignLeft = () => (
    <AlignLeftButton />
  );

  return config;
}